// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__194-k","modalForm":"UpgradeEpcsModal_modalForm__1_1dH","modalFooter":"UpgradeEpcsModal_modalFooter__36tA5"};